import type { EnumVisitType } from "@/Domain/EnumVisitType";
import { CacheService } from "./CacheService";
import { useMainStore } from "@/stores/useMainStore";
import moment from "moment";

export interface NewVisit {
  visitId: number;
  visitType: EnumVisitType;
  plantName: string;
}

export class NewVisitsService {
  static getKey() {
    const main = useMainStore();
    return `NewUnscheduledVisits;${main.userLogin}`;
  }

  static getNewVisits() {
    return CacheService.get(NewVisitsService.getKey(), () => [] as NewVisit[]);
  }

  static addNewVisit(
    visitId: number,
    visitType: EnumVisitType,
    plantName: string
  ) {
    const visits = NewVisitsService.getNewVisits();

    visits.push({ visitId, visitType, plantName });
    const expiresAt = moment().add(1, "year").toDate();
    CacheService.set(NewVisitsService.getKey(), visits, expiresAt);
  }

  static removeNewVisit(visitId: number) {
    const visits = NewVisitsService.getNewVisits();

    const index = visits.findIndex((v) => v.visitId === visitId);
    if (index < 0) return;
    visits.splice(index, 1);
    const expiresAt = moment().add(1, "year").toDate();
    CacheService.set(NewVisitsService.getKey(), visits, expiresAt);
  }
}
